import Carousel from "react-multi-carousel";
import React, { useState } from "react";
import MyReviewsStars from "src/components/shared/MyReviewsStars";

export const RoomReviewCard: React.FC<{
  roomReview: any;
  deleteReview: (reviewId: string) => void;
}> = ({ roomReview, deleteReview }) => {
  const [isDeleteButtonClicked, setIsDeleteButtonClicked] =
    useState<Boolean>(false);
  return (
    <div className="relative flex justify-start items-start space-x-[28px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[20px]">
      {/* rommReview album */}
      <div className="relative w-[340px] h-[220px] ">
        <Carousel
          additionalTransfrom={0}
          autoPlay
          autoPlaySpeed={3000}
          infinite
          draggable
          keyBoardControl
          showDots
          responsive={{
            desktop: {
              breakpoint: { max: 3000, min: 1024 },
              items: 1,
            },
            tablet: { breakpoint: { max: 1024, min: 640 }, items: 1 },
            mobile: { breakpoint: { max: 640, min: 0 }, items: 1 },
          }}
          slidesToSlide={1}
          swipeable
          customButtonGroup={<ButtonGroup />}
          arrows={false}
          renderButtonGroupOutside={true}
          customDot={<CustomDot />}
        >
          {roomReview.classroomAlbum.map((imageUrl: any, index: number) => (
            <img
              key={index}
              src={`${imageUrl}`}
              alt={`Room ${index + 1}`}
              className="big-image object-cover rounded-lg mx-auto w-[334px] h-[178px] md:w-[340x] md:h-[220px] sm:w-[334px] sm:h-[178px]"
            />
          ))}
        </Carousel>
      </div>
      {/* roomReview content */}
      <div className="w-full max-w-[500px] flex flex-col justify-start items-start space-y-[16px]">
        {/* room name & address & rating */}
        <div className="flex flex-col justify-start items-start space-y-[6px]">
          <div className="flex flex-col justify-start items-start">
            <span className="text-[#0F0220] font-inter font-semibold text-[22px] leading-[32px]">
              {roomReview.classroomName}
            </span>
            <div className="flex justify-start items-center space-x-[6px]">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_4125_31687)">
                  <path
                    d="M15 8C15 11.3137 9 17 9 17C9 17 3 11.3137 3 8C3 4.68629 5.68629 2 9 2C12.3137 2 15 4.68629 15 8Z"
                    stroke="#5C1025"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M9 8.75C9.41421 8.75 9.75 8.41421 9.75 8C9.75 7.58579 9.41421 7.25 9 7.25C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75Z"
                    fill="#5C1025"
                    stroke="#5C1025"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4125_31687">
                    <rect
                      width="18"
                      height="18"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <span className="text-[#5C1025] font-inter font-medium text-[12px] leading-[24px]">
                {roomReview.classroomAddress}
              </span>
            </div>
          </div>
          <MyReviewsStars rating={roomReview.rating}></MyReviewsStars>
        </div>

        {/* roomReview title & content */}
        <div className="flex flex-col justify-start items-start space-y-[2px]">
          <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
            {roomReview.title}
          </span>
          <span className="text-[#1F1F1F] font-inter font-normal text-[14px] leading-[24px] opacity-80">
            {roomReview.content}
          </span>
        </div>
      </div>
      {/* open delete review button */}
      <button
        type="button"
        className="absolute top-[12px] right-[8px]"
        onClick={() => {
          setIsDeleteButtonClicked(!isDeleteButtonClicked);
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {/* delete room review from list button */}
      {isDeleteButtonClicked && (
        <button
          className="absolute top-[55px] right-[3px] w-[201px] h-[56px] rounded-[12px] px-[20px] py-[8px] bg-white shadow-lg text-start"
          onClick={() => deleteReview(roomReview.id)}
        >
          <span className=" text-[#D22121] font-inter font-normal text-[14px] leading-[24px] text-start ">
            Delete Review
          </span>
        </button>
      )}
    </div>
  );
};

export const RoomReviewCardMobile: React.FC<{
  roomReview: any;
  deleteReview: (reviewId: string) => void;
}> = ({ roomReview, deleteReview }) => {
  const [isDeleteButtonClicked, setIsDeleteButtonClicked] =
    useState<Boolean>(false);
  return (
    <div className="relative flex flex-col justify-start items-start space-y-[10px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[6px]">
      {/* room name & address */}
      <div className="flex flex-col justify-start items-start space-y-[6px]">
        <div className="flex flex-col justify-start items-start">
          <span className="text-[#0F0220] font-inter font-semibold text-[22px] leading-[32px]">
            {roomReview.classroomName}
          </span>
          <div className="flex justify-start items-center space-x-[6px]">
            <svg
              width="18"
              height="19"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_4125_31687)">
                <path
                  d="M15 8C15 11.3137 9 17 9 17C9 17 3 11.3137 3 8C3 4.68629 5.68629 2 9 2C12.3137 2 15 4.68629 15 8Z"
                  stroke="#5C1025"
                  strokeWidth="1.5"
                />
                <path
                  d="M9 8.75C9.41421 8.75 9.75 8.41421 9.75 8C9.75 7.58579 9.41421 7.25 9 7.25C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75Z"
                  fill="#5C1025"
                  stroke="#5C1025"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_4125_31687">
                  <rect
                    width="18"
                    height="18"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>

            <span className="text-[#5C1025] font-inter font-medium text-[12px] leading-[24px]">
              {roomReview.classroomAddress}
            </span>
          </div>
        </div>
      </div>
      {/* rommReview album */}
      <div className="relative w-full h-[200px] overflow-hidden">
        <Carousel
          additionalTransfrom={0}
          autoPlay
          autoPlaySpeed={3000}
          infinite
          draggable
          keyBoardControl
          showDots
          responsive={{
            desktop: {
              breakpoint: { max: 3000, min: 1024 },
              items: 1,
            },
            tablet: { breakpoint: { max: 1024, min: 640 }, items: 1 },
            mobile: { breakpoint: { max: 640, min: 0 }, items: 1 },
          }}
          slidesToSlide={1}
          swipeable
          customButtonGroup={<ButtonGroup />}
          arrows={false}
          renderButtonGroupOutside={true}
          customDot={<CustomDot />}
        >
          {roomReview.classroomAlbum.map((imageUrl: any, index: number) => (
            <img
              key={index}
              src={`${imageUrl}`}
              alt={`Room ${index + 1}`}
              className="big-image object-cover rounded-lg mx-auto w-[330px] h-[200px]"
            />
          ))}
        </Carousel>
      </div>
      {/* roomReview rating */}
      <div className="flex justify-start items-center space-x-[6px]">
        <MyReviewsStars rating={roomReview.rating}></MyReviewsStars>
      </div>
      {/* roomReview title & content */}
      <div className="flex flex-col justify-start items-start space-y-[2px]">
        <span className="text-[#1E1E1E] font-inter font-bold text-[16px] leading-[25px]">
          {roomReview.title}
        </span>
        <span className="text-[#1F1F1F] font-inter font-normal text-[14px] leading-[24px] opacity-80">
          {roomReview.content}
        </span>
      </div>
      {/* <div className="w-full max-w-[500px] flex flex-col justify-start items-start space-y-[16px]"></div> */}
      {/* open delete review button */}
      <button
        type="button"
        className="absolute top-[12px] right-[8px]"
        onClick={() => {
          setIsDeleteButtonClicked(!isDeleteButtonClicked);
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 18.5C12.2761 18.5 12.5 18.2761 12.5 18C12.5 17.7239 12.2761 17.5 12 17.5C11.7239 17.5 11.5 17.7239 11.5 18C11.5 18.2761 11.7239 18.5 12 18.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6.5C12.2761 6.5 12.5 6.27614 12.5 6C12.5 5.72386 12.2761 5.5 12 5.5C11.7239 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.7239 6.5 12 6.5Z"
            fill="#0D0D0D"
            stroke="#0D0D0D"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {/* delete room review from list button */}
      {isDeleteButtonClicked && (
        <button
          className="absolute top-[55px] right-[3px] w-[201px] h-[56px] rounded-[12px] px-[20px] py-[8px] bg-white shadow-lg text-start"
          onClick={() => deleteReview(roomReview.id)}
        >
          <span className=" text-[#D22121] font-inter font-normal text-[14px] leading-[24px] text-start ">
            Delete Review
          </span>
        </button>
      )}
    </div>
  );
};

export const RoomReviewSkeleton: React.FC = () => {
  return (
    <div className="relative flex justify-start items-start space-x-[28px] w-full rounded-[14px] border-[1px] border-[#F5F5F5] p-[20px] animate-pulse">
      <div className="w-[112px] h-[112px] rounded-full bg-gray-300"></div>

      <div className="w-full max-w-[500px] flex flex-col justify-start items-start space-y-[12px]">
        <div className="flex flex-col justify-start items-start space-y-2 w-full">
          <div className="h-[24px] w-[60%] bg-gray-300 rounded-md"></div>{" "}
          <div className="h-[18px] w-[40%] bg-gray-300 rounded-md"></div>{" "}
          <div className="h-[18px] w-[100px] bg-gray-300 rounded-md"></div>{" "}
        </div>

        <div className="flex flex-col justify-start items-start space-y-[6px] w-full">
          <div className="h-[20px] w-[80%] bg-gray-300 rounded-md"></div>{" "}
          <div className="h-[16px] w-[100%] bg-gray-300 rounded-md"></div>{" "}
          <div className="h-[16px] w-[90%] bg-gray-300 rounded-md"></div>{" "}
        </div>
      </div>
    </div>
  );
};

const ButtonGroup = ({ next, previous }: any) => {
  return (
    <div className="w-full h-full absolute top-1/2 -translate-y-1/2 z-20">
      {/* Previous Button */}
      <button
        className="group transition-all duration-100  absolute left-3 top-1/2 -translate-y-1/2 h-[36px] w-[36px] rounded-full flex justify-center items-center bg-white bg-opacity-70 shadow-md hover:bg-opacity-100"
        onClick={previous}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="transition-all duration-100  stroke-[#1B0209] group-hover:stroke-[#E83C70]"
        >
          <path
            d="M10 4L6 8L10 12"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* Next Button */}
      <button
        className="group transition-all duration-200 absolute right-4 top-1/2 -translate-y-1/2 h-[36px] w-[36px] rounded-full flex justify-center items-center bg-white bg-opacity-70 shadow-md hover:bg-opacity-100"
        onClick={next}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="transition-all duration-200 stroke-[#1B0209] group-hover:stroke-[#E83C70]"
        >
          <path
            d="M6 12L10 8L6 4"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

const CustomDot = ({ onClick, active }: any) => {
  return (
    <button
      className={`w-[6px] h-[6px] mx-[4px] -mt-4 rounded-full transition-all duration-300 ${
        active ? "bg-white" : "bg-white opacity-35 "
      }`}
      onClick={onClick}
    />
  );
};
